import React from "react";
import { CircularProgress, Typography, Fade } from "@material-ui/core";

const LoadingSpinner = ({ marginTop = 12, size = 40, message = null, fade = false }) => {
  const spinnerContent = (
    <div style={{ textAlign: "center", marginTop, width: "100%" }}>
      <CircularProgress
        size={size}
        thickness={4}
      />
      {message && (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginTop: 8 }}
        >
          {message}
        </Typography>
      )}
    </div>
  );

  return fade ? <Fade in>{spinnerContent}</Fade> : spinnerContent;
};

export default LoadingSpinner;
